import StoreOrderDetailsNav from './StoreOrderDetailsNav';
import IncompleteDeliveryReportPanel from '@/modules/order/components/IncompleteDeliveryReportPanel';
import OrderStatus from '@/modules/order/components/OrderStatus';
import OrderDetails from '@/modules/order/pages/OrderDetails';
import ReorderButton from '@/modules/store/components/ReorderButton';
import { CartPath } from '@/modules/store/paths';
import { useNavigate } from 'react-router-dom';

const StoreOrderDetails = () => {
  const navigate = useNavigate();

  return (
    <OrderDetails
      renderNav={({
        order,
        onReceiveOrder,
        onReportIncompleteDelivery,
        hasReportedIncompleteDelivery,
      }) => (
        <StoreOrderDetailsNav
          order={order}
          onReceiveOrder={onReceiveOrder}
          onReportIncompleteDelivery={onReportIncompleteDelivery}
          hasReportedIncompleteDelivery={hasReportedIncompleteDelivery}
          reorderAction={<ReorderButton order={order} onSuccess={() => navigate(CartPath)} />}
        />
      )}
      counterparty={{
        label: 'Supplier:',
        getName: (order) => order.supplier?.name || '',
      }}
      renderOrderStatus={(order) => <OrderStatus order={order} />}
      renderOrderNotice={({ order }) =>
        order.unresolvedIncompleteDelivery ? (
          <IncompleteDeliveryReportPanel report={order.unresolvedIncompleteDelivery} />
        ) : null
      }
    />
  );
};

export default StoreOrderDetails;
